import React, { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';

const PageNotFound = () => {
    const { user } = useContext(AuthContext);
    return (
        <div>
            {user ? <h2>Page not found</h2> :
                <div className="lending-page-container">
                    <div className="container-fluid container-fluid-custom ">
                        <div>
                            <h1 className="lending-subtitle">Page not found</h1>
                        </div>
                    </div>
                </div>}
        </div>
    )
}
export default PageNotFound;


// WEBPACK FOOTER //
// ./src/components/pageNotFound/pageNotFound.js